import {HubConnection, HubConnectionBuilder, LogLevel} from '@microsoft/signalr';
import {useEffect, useState} from 'react';

function buildConnection() {
    return new HubConnectionBuilder()
        .withUrl(`${process.env.REACT_APP_API_URL}/api/v1/hubs/notifications`)
        .configureLogging(LogLevel.Warning)
        .withAutomaticReconnect()
        .build();
}

function isLoginPath() {
    return window.location.pathname === '/login';
}

export function useRealtimeConnection(): HubConnection | null {
    const [connection, setConnection] = useState<HubConnection | null>(null);

    useEffect(() => {
        connection?.stop();

        const newConnection = buildConnection();
        setConnection(newConnection);

        startConnection(newConnection);
        newConnection.onclose(() => startConnection(newConnection));
    }, []);

    return connection;
}

async function startConnection(newConnection: HubConnection) {
    try {
        if (!isLoginPath()) {
            await newConnection.start();
            console.log('SignalR Connected.');
            return;
        }
        setTimeout(() => startConnection(newConnection), 5000);
    } catch (err:any) {
        if (err.statusCode === 401 && !isLoginPath()) {
            // Redirect to login page
            window.location.href = '/login';
        }
        setTimeout(() => startConnection(newConnection), 5000);
    }
}
